export default function geoCountrySelection(wire, continents) {
    const normalize = (value) => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    return {
        countries: wire.entangle("editCountries"),
        mode: wire.entangle("editMode"),
        search: "",
        expanded: {},
        init() {
            for (const continent of Object.keys(continents)) {
                this.expanded[continent] = this.count(continent) > 0;
            }
        },
        count(continent) {
            return Object.keys(continents[continent]).filter((code) => this.countries.includes(code)).length;
        },
        toggleContinent(continent) {
            const codes = Object.keys(continents[continent]);
            this.countries = this.count(continent) === codes.length
                ? this.countries.filter((code) => !codes.includes(code))
                : [...new Set([...this.countries, ...codes])];
            this.expanded[continent] = true;
        },
        matches(name, code = "") {
            return normalize(name + " " + code).includes(normalize(this.search.trim()));
        },
        visible(continent) {
            return Object.entries(continents[continent]).some(([code, name]) => this.matches(name, code));
        },
        get hasResults() {
            return Object.keys(continents).some((continent) => this.visible(continent));
        },
    };
}
